
export default class URLUTMGetter
{
    constructor(allowOwnHostReferral = false) {
        this.allowOwnHostReferral = allowOwnHostReferral;
    }
    get() {
        const urlParams = new URLSearchParams(window.location.search);
        let utm_source = urlParams.get('utm_source');
        let utm_medium = urlParams.get('utm_medium');
        let utm_campaign = urlParams.get('utm_campaign');
        let utm_content = urlParams.get('utm_content');
        let utm_term = urlParams.get('utm_term');

        if (!utm_source && !utm_medium) {
            const ownHost = window.location.host.replace('www.', '');
            let referrer = document.referrer;

            if (this.allowOwnHostReferral || !referrer.includes(ownHost)) {
                if (referrer.includes(ownHost)) {
                    referrer = window.location.host;
                }
                if (referrer == '' || !referrer) {
                    utm_source = 'direct';
                    utm_medium = window.location.host;
                } else {
                    const searchEngine = this._checkIfIsSearchEngine(referrer);
                    if (searchEngine) {
                        utm_source = searchEngine;
                        utm_medium = 'organic';
                    } else {
                        utm_source = referrer;
                        utm_medium = 'referral';
                    }
                }
            }
        }

        return {
            source: utm_source,
            medium: utm_medium,
            campaign: utm_campaign,
            content: utm_content,
            term: utm_term
        }
    }

    _checkIfIsSearchEngine(referrer) {
        const searchEngines = ['google', 'bing', 'yahoo', 'duckduckgo', 'ecosia', 'qwant', 'baidu', 'yandex', 'search.brave'];
        return searchEngines.find(engine => referrer.includes(engine));
    }
}
